import { render } from "./inventorycategory.vue?vue&type=template&id=5ed31438&scoped=true"
import script from "./inventorycategory.vue?vue&type=script&lang=js"
export * from "./inventorycategory.vue?vue&type=script&lang=js"

import "./inventorycategory.vue?vue&type=style&index=0&id=5ed31438&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ed31438"]])

export default __exports__